// src/components/CompanyIntro.js
import React from "react";

function CompanyIntro() {
  return (
    <section className="about" id="about">
      <div className="section-inner">
        <div className="about-grid">

          {/* Left: Text Content */}
          <div className="about-content">
            <div className="section-tag">
              <i className="fas fa-building"></i> About Us
            </div>
            <h2 className="section-title">
              A Startup Built to Transform Businesses Digitally
            </h2>
            <p className="section-subtitle">
              MechFolks Technologies is a modern technology company based in Bangalore, India —
              specializing in <strong>Data Engineering</strong>, <strong>Web Development</strong>,
              and <strong>Digital Marketing</strong> solutions for startups, growing businesses,
              and enterprises.
            </p>
            <p className="section-subtitle" style={{marginTop: "16px"}}>
              We design scalable data pipelines, high-performance web platforms, and
              result-driven digital marketing strategies that transform raw potential into
              real business growth.
            </p>

            <ul className="about-list">
              <li>
                <i className="fas fa-check-circle"></i>
                End-to-end Data Engineering: ETL pipelines, Azure Databricks, cloud data lakes
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                Custom websites &amp; web apps built with React, modern APIs &amp; best practices
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                Performance-driven Digital Marketing: SEO, Social Media, Paid Ads &amp; more
              </li>
              <li>
                <i className="fas fa-check-circle"></i>
                Transparent process, agile delivery &amp; dedicated post-launch support
              </li>
            </ul>
          </div>

          {/* Right: Stat Cards */}
          <div className="about-card-grid">
            <div className="about-stat-card">
              <div className="card-icon">⚡</div>
              <h3>5+</h3>
              <p>Years of Industry Experience</p>
            </div>
            <div className="about-stat-card">
              <div className="card-icon">🚀</div>
              <h3>10+</h3>
              <p>Projects Successfully Delivered</p>
            </div>
            <div className="about-stat-card">
              <div className="card-icon">🌍</div>
              <h3>3 Core Services</h3>
              <p>Data Engineering · Web Development · Digital Marketing — all under one roof</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default CompanyIntro;
